/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Dmitri Puscas <degwelloa@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */


import {Picture} from './Picture';

/**
 * deletePicture is a flag which
 * says that user wants to delete picture
 * When such event is emmit - then flag becoming true
 * and backend deletes file and record in db
 */
export interface Promotion {
  id?: number;
  anons?: string;
  content: string;
  targetUrl?: string;
  header: string;
  createdAt?: Date;
  updatedAt?: Date;
  picture?: Picture;
  enabled?: boolean;
  deleted?: boolean;
}
